<ng-template #selectAll>
	<mat-option (click)="toggleSelectAll()">
		<mat-pseudo-checkbox class="mat-option-pseudo-checkbox" [state]="state">
		</mat-pseudo-checkbox>
		{{ props.selectAllLabel }}
	</mat-option>
</ng-template>

<mat-form-field class="full-width">
	<mat-label>{{ props.label }}</mat-label>
	<mat-select placeholder="Select" multiple [formControl]="formControl">
		<mat-select-trigger>
			{{ getDisplay() }}
		</mat-select-trigger>
		<ng-container [ngTemplateOutlet]="selectAll"></ng-container>
		<mat-option *ngFor="let option of selectOptions" [value]="option.value" (click)="handleCheckboxSelection(option.value)">
			{{option.label}}
		</mat-option>
	</mat-select>
	<mat-error>{{getErrorMessage()}}</mat-error>
</mat-form-field>